import { useEffect, useState } from 'react';

// Set initial value to true to avoid flicker
let _canCopyClipboard = true;

async function checkCopyToClipboardAccess() {
  try {
    if ('navigator' in globalThis && 'permissions' in navigator) {
      const { state } = await navigator.permissions.query({
        name: 'clipboard-write' as any,
      });
      _canCopyClipboard = state === 'granted';
    } else {
      // if no navigator or permissions, assume clipboard access is available (e.g. firefox)
      _canCopyClipboard = true;
    }
    return _canCopyClipboard;
  } catch (ex) {
    // Firefox does not have a clipboard-write permission and will always throw
    _canCopyClipboard = true;
    return _canCopyClipboard;
  }
}

// Run on init to avoid component flicker
checkCopyToClipboardAccess();

export const useNavigatorPermission = () => {
  const [canCopyClipboard, setCanCopyClipboard] = useState(_canCopyClipboard);

  // re-check access on load
  useEffect(() => {
    checkCopyToClipboardAccess().then(setCanCopyClipboard);
  }, []);

  return {
    canCopyClipboard,
  };
};
